import { useCallback } from "react";

import { State } from "@/state";
import { ThreadMessageContextItemType } from "@/state/@types";

export function appendToMessageContext(items: ThreadMessageContextItemType[]) {
  const { activeMessageContext, setActiveMessageContext } = State.getState();
  const merged = [...activeMessageContext];
  for (const item of items) {
    if (!merged.some((existing) => existing.id === item.id)) {
      merged.push(item);
    }
  }
  setActiveMessageContext(merged);
}

export function threadContextFromCheckedRows<T extends { id: string }>(
  rows: T[],
  checkedRowIds: string[],
  toContext: (row: T) => ThreadMessageContextItemType,
): ThreadMessageContextItemType[] {
  const rowById = new Map(rows.map((row) => [row.id, row]));
  return checkedRowIds
    .map((id) => rowById.get(id))
    .filter((row): row is T => row != null)
    .map(toContext);
}

export function usePrepareDataViewThread<T extends { id: string }>(
  rows: T[],
  toContext: (row: T) => ThreadMessageContextItemType,
) {
  return useCallback(
    (checkedRowIds: string[], draft?: string) => {
      const contextItems = threadContextFromCheckedRows(
        rows,
        checkedRowIds,
        toContext,
      );
      appendToMessageContext(contextItems);
      if (draft) {
        State.getState().setComposerDraft(draft);
      }
      State.getState().openThreadPanel();
    },
    [rows, toContext],
  );
}
